export default __webpack_public_path__ + "static/media/gallery_05.e30d3770.jpg";